import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    Location:"",
    TableName:"",
    PageNumber:"",
}

const PaginationSlice = createSlice({
    name: "PaginationSlice",
    initialState,

    reducers: {
        PaginationData(state, action) {
            return {
                Location:action.payload.Location,
                PageNumber:action.payload.PageNumber,
                TableName:action.payload.TableName,
            };
        }
    }
})
export const { PaginationData } = PaginationSlice.actions;
export default PaginationSlice.reducer;